import { GhostErrorButton } from 'ui/button';
import styled from 'styled-components';
import { spacing, fontWeights, colors, smallShadow } from 'ui/theme';

export const Container = styled.div`
  display: grid;
  gap: ${spacing.half};
  grid-template-columns: 1fr;
  grid-template-rows: ${spacing.double} auto 1fr;
  place-items: start center;
  z-index: 0;
`;
export const InputsContainer = styled.div`
  width: 100%;
  height: ${spacing.x16};
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
  border: ${spacing.single} solid ${colors.grey15};
`;

export const InputContainer = styled.div`
  position: relative;
  margin: ${spacing.base};
`;

export const FractionalInputContainer = styled.div`
  ${smallShadow};
  border: ${spacing.single} solid ${colors.grey15};
  position: relative;
  margin: ${spacing.base};
`;

export const StyledGhostErrorButton = styled(GhostErrorButton)`
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
`;

export const StyledFractionalGhostErrorButton = styled(GhostErrorButton)`
  position: absolute;
  right: ${spacing.quarter};
  top: ${spacing.quarter};
`;

export const HeaderContainer = styled.div`
  align-items: center;
  display: flex;
  font-weight: ${fontWeights.bold};
  gap: ${spacing.half};
  place-self: center;
`;

export const HeaderText = styled.span`
  &[data-disabled='true'] {
    color: ${colors.textDisabled};
  }
`;
